// https://vuex.vuejs.org/en/mutations.html

export default {
  authUser(state, userData) {
    state.Token = userData.token;
    state.userType = userData.userType;
    state.userId = userData.userId;
    state.mail = userData.mail;
    state.companyId = userData.companyId;
    state.isUserLoggedIn = userData.isUserLoggedIn;
    state.username = userData.username;
  },
  signOutUser(state, userData) {
    state.Token = userData.token;
    state.userType = userData.userType;
    state.userId = userData.userId;
    state.mail = userData.mail;
    state.companyId = userData.companyId;
    state.isUserLoggedIn = userData.isUserLoggedIn;
    state.project = userData.project;
    state.projectsArr = userData.projectsArr;
    state.subProjectsArr = userData.subProjectsArr;
    state.subProject = userData.subProject;
    state.devices = userData.devices;
    state.data = userData.data;
    state.data2 = userData.data2;
    state.CEReports = userData.CEReports;
  },
  project(state, data) {
    state.project = data;
  },
  projects(state, data) {
    state.projects = data;
  },
  projectsArr(state, data) {
    state.projectsArr = data;
  },
  subProjectsArr(state, data) {
    state.subProjectsArr = data;
  },
  agroUnitsArr(state, data) {
    state.agroUnits = data;
  },
  agroUnitsIds(state, data) {
    state.agroUnitsIds = data;
  },
  subProject(state, data) {
    state.subProject = data;
  },
  subProjectId(state, data) {
    state.subProjectId = data;
  },
  devicesArr(state, data) {
    state.devices = data;
  },
  dataArr(state, data) {
    state.data = data;
  },
  dataArr2(state, data) {
    state.data2 = data;
  },
  agroBot(state, data) {
    state.agroBot = data;
  },
  agroBotComp(state, data) {
    state.agroBotComp = data;
  },
  agroBotBasic(state, data) {
    state.agroBotBasic = data;
  },
  agroBotLight(state, data) {
    state.agroBotLight = data;
  },
  agroBee(state, data) {
    state.agroBee= data;
  },
  alerts(state, data) {
    state.alerts = data
  },
  alertsResolved(state, data) {
    state.alertsResolved = data
  },
  agroBotSoil(state, data) {
    state.agroBotSoil = data;
  },
  proDevices(state, data) {
    state.proDevices = data;
  },
  CEReports(state, data) {
    state.CEReports = data;
  },
  meteo(state, data) {
    state.meteo = data;
  },
  modal(state, data) {
    state.modal = data;
  },
  modal2(state, data) {
    state.modal2 = data;
  },
  modal3(state, data) {
    state.modal3 = data;
  },
  irrigationInstructions(state, data) {
    state.irrigationInstructions = data;
  },
  splitIrrigationInstructions(state, data) {
    state.splitIrrigationInstructions = data;
  },
  splitPulses(state, data) {
    state.splitPulses = data;
  },
  pulses(state, data) {
    state.pulses = data;
  },
  pulsesTable(state, data) {
    state.pulsesTable = data;
  },
  pulsesHeaders(state, data) {
    state.pulsesHeaders = data;
  },
  configPulse(state, data) {
    state.configPulse = data;
  },

  // PLAGUES REPORTS
  plaguesReports(state, data) {
    state.plaguesReports = data;
  },
  agroUnits(state, data) {
    state.agroUnits = data;
  },
};
